// src/quality-management/components/ConfirmationModal.tsx
// Reescrito sobre o Modal genérico do UI kit (nova identidade)

import React from 'react';
import { Modal } from '../../shared/components/ui/Modal';
import { Button } from '../../shared/components/ui/Button';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
  projectName?: string;
}

const confirmVariant = {
  danger: 'danger',
  warning: 'primary',
  info: 'success',
} as const;

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  type = 'warning',
  projectName,
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      data-testid="confirmation-modal"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            {cancelText}
          </Button>
          <Button variant={confirmVariant[type]} onClick={handleConfirm} data-testid="confirmation-confirm">
            {confirmText}
          </Button>
        </>
      }
    >
      <p className="text-base text-foreground-muted">{message}</p>
      {projectName && (
        <div className="mt-4 rounded-lg border border-border bg-surface-2 px-4 py-3">
          <p className="text-xs font-medium uppercase tracking-wide text-foreground-subtle">Projeto</p>
          <p className="mt-0.5 text-base font-medium text-foreground">{projectName}</p>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmationModal;
